import { TransactionType } from "./transaction-type-component.domain";


export type TransactionTypeRateValue = {
  transactionTypes: TransactionType[],
  rate: number,
  additionalDocFee: number,
} | null;
